module.exports = "<div class=\"row\">\n\t<div class=\"col-xs-12\">\n\t\t<h1 class=\"text-center\">STATISTICHE RATE</h1>\n\t</div>\n</div>"